import DataTable from "../../1. Core/Controls/DataTable/DataTable";
import Control from "../../1. Core/Control";
import NP from "../../1. Core/NP";
import {Pack} from "../types";
import {ServerAPI} from "../../1. Core/ServerAPI";
import TopAppBar from "../../1. Core/Controls/TopAppBar/TopAppBar";
import IconToggleButton from "../../1. Core/Controls/IconToggleButton/IconToggleButton";
import Menu from "../../1. Core/Controls/Menu/Menu";
import ListItem from "../../1. Core/Controls/ListBox/ListItem";
import EditPackDialog from "./EditPackDialog";
import Delegate from "../../1. Core/Delegate";
import {PageMode} from "../../10. Battle/types";
import PackCardTable from "./PackCardTable";

export default class PackTable extends Control {
    private _dataTable: DataTable;
    private _topAppBar: TopAppBar;
    private _CollectionId: number;
    private EvBackClick: Delegate;
    private _rootNode: HTMLElement
    private _drillDownPanel: PackCardTable;

    constructor(settings: object) {
        super(settings);
        this._render();
    }

    _initFields(settings: object) {
        this._CollectionId = null
        this.EvBackClick = new Delegate();
        super._initFields(settings);
    }

    getTopAppBar() {
        return this._topAppBar;
    }

    _render() {
        this.np_render();
        this.addClass('');

        this._rootNode = NP.createNode(this._root);

        this._topAppBar = new TopAppBar({
            Caption: "Packs of collection " + this._CollectionId,
            Class: 'top-app-bar--no-shadow top-app-bar--light library-box-list__app-bar',
            ParentNode: this._rootNode,
            ShowSearchButton: false,
            RightItems: NP.getCurrentUser().isBDAdmin() ? [
                new IconToggleButton({
                    FontImage: NP.FontImages.add,
                    EvClick: () => new EditPackDialog({
                        CollectionId: this._CollectionId,
                        EvOkButtonClick: () => this.refresh()
                    }).show()
                }),
            ] : [],
            EvBackClick: () => this.EvBackClick.fire(this)
        });
        this._topAppBar.setShowBackButton(true);

        this._dataTable = new DataTable({
            ParentNode: this._rootNode,
            Columns: [
                {Content: "Id", PropertyContent: "id", Width: "10%"},
                {Content: "Name EN", PropertyContent: "name_en", Width: "20%"},
                {Content: "Name RU", PropertyContent: "name_ru", Width: "20%"},
                {Content: "Name ES", PropertyContent: "name_es", Width: "20%"},
                {Content: "Name PT", PropertyContent: "name_pt", Width: "20%"},
                {Content: "Gift", PropertyContent: "completion_gift", Width: "20%"},
                {Content: "Background", PropertyContent: "background_color", Width: "20%"},
            ],
            EvItemClick: (s: object, e: { Item: Pack }) => {
                this.showCardList(e.Item);
            },
            ShowSettingsButton: true,
            EvItemContextMenu: async (s: any, e: { Event: any, Item: Pack }) => {
                let menu = new Menu({
                    Items: [
                        {FontImage: NP.FontImages.edit, RK: "Edit", Value: "Edit"},
                        {FontImage: NP.FontImages.delete, RK: "Remove", Value: "Remove"},
                    ],
                    EvItemSelected: async (s: Menu, event: { Item: ListItem }) => {
                        switch (event.Item.getValue()) {
                            case "Edit":
                                new EditPackDialog({
                                    Pack: e.Item,
                                    EvOkButtonClick: () => this.refresh()
                                }).show();
                                break;
                            case "Remove":
                                NP.showConfirm({
                                    Content: "Удалить pack?",
                                    EvOkButtonClick: async () => {
                                        await ServerAPI.delet("/fantasy/card-collections/packs/" + e.Item.id);
                                        this.refresh();
                                    }
                                });
                                break;
                        }
                    }
                });
                menu.showContextMenu(e.Event);
            }
        });

        this.refresh();
    }

    async refresh() {
        let packs = await ServerAPI.get<Pack[]>(
            `/fantasy/card-collections/packs?collectionId=${this._CollectionId}`,
        );
        this._dataTable.setRows(packs);
    }

    showCardList(col: Pack) {
        NP.updateBrowserUrlString(true, PageMode.pack_collection, col.id);

        NP.hideNode(this._rootNode);


        this._drillDownPanel = new PackCardTable({
            ParentNode: this._root,
            Width: this._Width,
            Event: event,
            Height: this._Height,
            PackId: col.id,
            EvBackClick: () => {
                NP.updateBrowserUrlString(true, PageMode.pack_collection);
                NP.showNode(this._rootNode);
                this._drillDownPanel.destroy();
                this._drillDownPanel = null;
                this.refresh();
            }
        })
    }
}